export default { version: 'v1.1.0' };
